import script from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"

import "./BasicInfo.vue?vue&type=style&index=0&id=f5380f50&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5380f50"]])

export default __exports__